import React, { useState, useEffect } from "react";
import "./styles/TeamCommunity.css";
import Footer from "./Footer";

const TeamCommunityDetails = () => {
  const [recentTeams, setRecentTeams] = useState([]);

  useEffect(() => {
    fetch("https://poke-meta.com/api/latestteamcomps")
      .then((res) => res.json())
      .then((data) => setRecentTeams(data))
      .catch((err) => console.error("Fehler beim Laden der neuesten Teamcomps:", err));
  }, []);

  return (
    <div className="teamcomp-details-container">
      <h1 className="teamcomp-details-title">Newest Community Teamcomps</h1>
      <p>Here are the latest 10 Community Team-Builds.</p>

      {recentTeams.length === 0 ? (
        <p>No Builds Found.</p>
      ) : (
        recentTeams.map((team, index) => (
          <div key={index} className="team-box"> {/* Container für jede Teamcomp */}
            <h2>{team.description}</h2>

            {/* Teamcomp Grid */}
            <div className="grid-wrapper">
              {Array.from({ length: 4 }, (_, rowIndex) => (
                <div key={rowIndex} className={`grid-row ${rowIndex % 2 === 1 ? "offset" : ""}`}>
                  {Array.from({ length: 5 }, (_, colIndex) => {
                    const pos = rowIndex * 5 + colIndex + 1;
                    const cell = team.pokemon_positions?.find(p => Number(p.pos) === pos);
                    return (
                      <div key={colIndex} className="grid-cell">
                        {cell ? <img src={cell.image} alt="Pokemon" className="grid-pokemon" /> : null}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>

            {/* Extra Pokémon & Helditems */}
            <div className="extra-pokemon-container">
              <h2>Optimal Pokémon & Helditems</h2>
              <p>Focus on this carry Pokémon and Helditems</p>
              {team.extra_pokemons.map((pokemon, index) => (
                <div key={index} className="extra-pokemon-row">
                  <div className="extra-pokemon-slot">
                    {pokemon ? <img src={pokemon} alt="Extra Pokemon" className="grid-pokemon" /> : null}
                  </div>
                  <div className="extra-tiles">
                    {(team.extra_tiles[index] || []).map((tile, tileIndex) => (
                      <div key={tileIndex} className="extra-tile">
                        {tile ? <img src={tile} alt="Helditem" className="helditem" /> : null}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
      <Footer />
    </div>
  );
};

export default TeamCommunityDetails;
